import { render, staticRenderFns } from "./PositionField.vue?vue&type=template&id=fd96e18a&scoped=true"
import script from "./PositionField.vue?vue&type=script&lang=js"
export * from "./PositionField.vue?vue&type=script&lang=js"
import style0 from "./PositionField.vue?vue&type=style&index=0&id=fd96e18a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd96e18a",
  null
  
)

export default component.exports